import './App.css'
import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Loader from './components/loader'
import ProtectedRoutes from './routing/ProtectedRoutes'
import PreventReLogin from './routing/PreventReLogin'
import Login from './pages/Auth/Login'
import ErrorPage from './pages/ErrorPage'
import UserListing from './pages/user/UserListing'
import ExpertListing from './pages/experts/ExpertListing'
import AddExpert from './pages/experts/AddExpert'
import AddUser from './pages/user/AddUser'
import AddEditShift from './pages/master/shift/AddEditShift'
import DomainListing from './pages/master/domain/DomainListing'
import AddEditDomain from './pages/master/domain/AddEditDomain'
import AddEditDegree from './pages/master/degree/AddEditDegree'
import DegreeListing from './pages/master/degree/DegreeListing'
import ExpertAvailability from './pages/experts/availability/ExpertAvailability'
import UserBookSlotListing from './pages/user/bookslot/UserBookSlotListing'
import AddUserBookSlot from './pages/user/bookslot/AddUserBookSlot'
import ExpertUserBookedSlot from './pages/experts/managebookedslot/ExpertUserBookedSlot'
import UserRegistration from './components/registration/UserRegistration'
import ExpertRegistration from './components/registration/ExpertRegistration'
import AddUserBookSlotMain from './pages/user/bookslot/AddUserBookSlotMain'
import UserProfile from './pages/UserProfile'
import ExpertProfile from './pages/ExpertProfile'
import AddEditLocation from './pages/master/location/AddEditLocation'
import LocationListing from './pages/master/location/LocationListing'
import StateDistrictListing from './pages/master/statedistrict/StateDistrictListing'
import AddEditStateDistrict from './pages/master/statedistrict/AddEditStateDistrict'
import UnBlockBookedExp from './components/UnBlockBookedExp'
import ViewAllBookedSlots from './pages/ViewAllBookedSlots'
import UnblockExpSlotsPublic from './pages/UnblockExpSlotsPublic'
import LocationWiseExpSlots from './pages/LocationWiseExpSlots'
import ForgotPassword from './pages/Auth/ForgotPassword'
// import RegisterNow from './pages/Auth/RegisterNow'





const Dashboard = React.lazy(() => import('./pages/dashboard/Dashboard'))

// TODO: Set default isAuthorized value to false (true : testing) except "/" (home path)
const protectedRoutes = [
  {
    path: '/',
    element: <Dashboard />,
    isAuthorized: true
  },
  {
    path: '/unBlockBookedExp',
    element: <UnBlockBookedExp />,
    isAuthorized: true
  },
  {
    path: '/locationWiseExpSlots',
    element: <LocationWiseExpSlots />,
    isAuthorized: true
  },
  {
    path: '/user/userListing',
    element: <UserListing />,
    isAuthorized: false
  },
  {
    path: '/user/userListing/add',
    element: <AddUser />,
    isAuthorized: false
  },
  
  {
    path: '/user/userListing/userbookslot/:id',
    element: <UserBookSlotListing />,
    isAuthorized: false
  },
  {
    path: '/user/userListing/userbookslot/add/:id',
    element: <AddUserBookSlot />,
    isAuthorized: false
  },
  {
    path: '/user/userListing/edit/:id',
    element: <UserProfile />,
    isAuthorized: false
  },
  {
    path: '/user/userListing/userbookslot/bookslotmain/add/:id/:id2/:id3',
    element: <AddUserBookSlotMain />,
    isAuthorized: false
  },
  {
    path: '/expert/expertListing',
    element: <ExpertListing />,
    isAuthorized: false
  },
  {
    path: '/expert/expertListing/edit/:id',
    element: <ExpertProfile />,
    isAuthorized: false
  },
  {
    path: '/expert/expertListing/manageexpertAvailability/:id',
    element: <ExpertAvailability />,
    isAuthorized: false
  },
  {
    path: '/expert/expertListing/add',
    element: <AddExpert />,
    isAuthorized: false
  },
  {
    path: '/expert/expertListing/manageexpertslotbooking/:id',
    element: <ExpertUserBookedSlot />,
    isAuthorized: false
  },
  
  {
    path: '/master/shiftListing',
    element: <AddEditShift />,
    isAuthorized: false
  },
  
  {
    path: '/master/domainListing',
    element: <DomainListing />,
    isAuthorized: false
  },
  {
    path: '/master/domainListing/add',
    element: <AddEditDomain />,
    isAuthorized: false
  },
  {
    path: '/master/domainListing/add/:id',
    element: <AddEditDomain />,
    isAuthorized: false
  },
  {
    path: '/master/degreeListing',
    element: <DegreeListing />,
    isAuthorized: false
  },
  {
    path: '/master/degreeListing/add',
    element: <AddEditDegree />,
    isAuthorized: false
  },
  {
    path: '/master/degreeListing/add/:id',
    element: <AddEditDegree />,
    isAuthorized: false
  },
  {
    path: '/master/locationListing',
    element: <LocationListing />,
    isAuthorized: false
  },
  {
    path: '/master/locationListing/add',
    element: <AddEditLocation />,
    isAuthorized: false
  },
  {
    path: '/master/locationListing/add/:id',
    element: <AddEditLocation />,
    isAuthorized: false
  },
  {
    path: '/master/stateDistrictListing',
    element: <StateDistrictListing />,
    isAuthorized: false
  },
  {
    path: '/master/stateDistrictListing/add/:id',
    element: <AddEditStateDistrict />,
    isAuthorized: false
  },
  {
    path: '/master/stateDistrictListing/add',
    element: <AddEditStateDistrict />,
    isAuthorized: false
  },
  {
    path: '/bookslot',
    element: <AddUserBookSlot />,
    isAuthorized: false
  },
  {
    path: '/bookslot/:id',
    element: <AddUserBookSlot />,
    isAuthorized: false
  },
  {
    path: '/bookslot/:id/:id2',
    element: <AddUserBookSlotMain />,
    isAuthorized: false
  },
  {
    path: '/mybookings',
    element: <UserBookSlotListing />,
    isAuthorized: false
  },
  {
    path: '/expertavailability',
    element: <ExpertAvailability />,
    isAuthorized: false
  },
  {
    path: '/bookedslots',
    element: <ExpertUserBookedSlot />,
    isAuthorized: false
  },
  {
    path: '/myprofile',
    element: <UserProfile />,
    isAuthorized: false
  },
  
  {
    path: '/myexpertprofile',
    element: <ExpertProfile />,
    isAuthorized: false
  },
  {
    path: '/bookedSlot',
    element: <ViewAllBookedSlots />,
    isAuthorized: false
  }
 
  
 
  
];
 

function App () {
  const { authorizedRoutes } = useSelector(state => state.user)
console.log("authorizedRoutes= ",authorizedRoutes)
  const authorizedPaths = authorizedRoutes
    ? authorizedRoutes.map(item => item.path)
    : []
  protectedRoutes.forEach(route => {
    if (authorizedPaths.includes(route.path)) {
      route.isAuthorized = true
    }
  })

  return (
    // <BrowserRouter basename={"/paramarshApp"} >
    <BrowserRouter  >
      <Routes>
        <Route element={<ProtectedRoutes />}>
          {protectedRoutes.map((route, index) => {
            return route.isAuthorized ? (
              <Route
                path={route.path}
                key={index}
                element={
                  <React.Suspense fallback={<Loader />}>
                    {route.element}
                  </React.Suspense>
                }
              />
            ) : (
              ''
            )
          })}
        </Route>
        {/* <Route path='*' element={<Login />} /> */}
        <Route element={<PreventReLogin />}>
          <Route path='/login' element={<Login />} />
          <Route path='/userRegistration' element={<UserRegistration />} />
          <Route path='/expertRegistration' element={<ExpertRegistration />} />
          <Route path='/unblockSlots' element={<UnblockExpSlotsPublic />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          {/* <Route path='/reset-password' element={<ResetPassword />} /> */}
          <Route path='*' element={<Login />} />   

        </Route>
        <Route path='*' element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
